import { getFirstUrl } from './login';

export const transferIdParams = {
    operate_source: 'web',
    first_url: getFirstUrl(),
    channel: window.sessionStorage.getItem('channel'),
    // user_type: getStore().getState().userInfoModel.userInfo?.is_vip ? 1 : 0
};
